export default "__VITE_PUBLIC_ASSET__f762425a__"